import { Navigate } from "react-router-dom";
import { hasPermission } from "store";
import NoAccess from "components/NoAccess"; 

export default function RedirectToFirstPermitted({
  basePath,
  items,
  fallback = <NoAccess />
}) {
  const isPermitted = p => Array.isArray(p) ? p.some(hasPermission) : hasPermission(p)
  const firstAllowed = items.find(i => isPermitted(i.permission));

  if (!firstAllowed) {
    return fallback;
  }

  return (
    <Navigate
      to={`${basePath}/${firstAllowed.path}`}
      replace
    />
  );
}

